export default class Models {

    listaConturi = [
        {tip:'Cheltuieli',
        conturi:[
            {cont:'1011', descriere:'Capital Subscris Nevarsat'},
            {cont:'1012', descriere:'Capital Subscris Varsat'},
            {cont:'1015', descriere:'Patrimoniul Regiei'}
        ]
        },
        {
            tip:'Venituri',
            conturi:[
                {cont:'7812', descriere:'Venituri din provizioane'},
                {cont:'7815', descriere:'Venituri din fondul comercial negativ'},
                {cont:'786', descriere:'Venituri financiare din amortizari si ajustari pentru pierdere de valoare'}
            ]
        }
    ]

} //end class